export const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'];
